import { useModals } from "@/features/modals/hooks";
import { type WidgetSettingsDefinition } from "@repo/api";
import { ListViewItem, warehouseIcon } from "@repo/skapa";
import { t } from "@repo/translation";

export const TagSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { pushModal } = useModals();
  const selectedTags = setting[settingDefinition.id] ?? [];

  return (
    <ListViewItem
      control="navigational"
      title={t("label.tags")}
      description={
        selectedTags.length > 0 ? selectedTags.join(", ") : undefined
      }
      onClick={() =>
        pushModal({
          type: "SELECT_TAG",
          selected: selectedTags,
          onAsyncUpdate: (tags: string[]) => {
            setSetting({ [settingDefinition.id]: tags });
            return Promise.resolve();
          },
        })
      }
      leadingIcon={warehouseIcon}
    />
  );
};
